//Input that takes a search term and calls the search function
import React, { useState } from "react";
import { TextField } from "@mui/material";
const Search = ({ search, width, labelValue }) => {
    const [term, setTerm] = useState("");
    const onFormSubmit = (event) => {
        event.preventDefault();
        search(term);
    };
    const onInputChange = (event) => {
        const newTerm = event.target.value;
        setTerm(newTerm);
        search(newTerm);
    };
    return (React.createElement("form", { onSubmit: onFormSubmit },
        React.createElement(TextField, { label: labelValue || "Search", variant: "outlined", value: term, onChange: onInputChange, style: { width: width || "100%" } })));
};
export default Search;
